import css from './BarTimer.module.scss'
import React from 'react'
import classNames from 'classnames'

interface Props {
  initialTime: number
  currentTime: number
}

const BarTimer: React.FC<Props> = (props) => {
  const { initialTime, currentTime } = props

  return (
    <div className={css.wrapper}>
      <div
        className={classNames(css.text, {
          [css.yellow]: currentTime <= 10 && currentTime > 5,
          [css.red]: currentTime <= 5,
        })}
      >
        {currentTime} sec.
      </div>

      <div className={css.bar}>
        <div
          className={classNames(css.regress, {
            [css.yellow]: currentTime <= 10 && currentTime > 5,
            [css.red]: currentTime <= 5,
          })}
          style={{ height: '100%', width: `${(currentTime / initialTime) * 100}%` }}
        />
      </div>
    </div>
  )
}

export default BarTimer
